const LegalHero = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  return (
  <section>
    <div className="card text-white border-0">
      {/* Responsive image wrapper with fixed height */}
      <div className="card-img-wrapper">
        <img src={`${awsImageBaseUrl}images/PeoplePurposet/people-purpose.jpg`} className="card-img rounded-0" alt="Hero Background" />
      </div>
      {/* Overlay Content */}
      <div className="card-img-overlay text-center hero-overlay d-flex flex-column">
        <div className="container mt-auto mb-0 mb-lg-2">
          <div className="row justify-content-center">
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};

export default LegalHero;
